import * as amendBookings from 'store/actions/bookings/amendBookings';
import * as fetchBookings from 'store/actions/bookings/fetchBookings';
import * as updateBookings from 'store/actions/bookings/updateBookings';
import * as cancelBookings from 'store/actions/bookings/cancelBookings';
import * as exportBookings from 'store/actions/bookings/exportBookings';
import * as exportFullBookings from 'store/actions/bookings/fullBookingExport';
import * as types from 'store/actions/types';
import apiClient from 'clients/apiClient';
import config from 'helpers/config';
import { put, select, takeEvery } from 'redux-saga/effects';
import { showNotification } from 'store/actions/uiActions';
import { updateBookingAmendRequest } from 'http/requests/bookings/amendBookingsRequests';

const getBookingStore = (state) => {
    return state.bookings;
};

function* fetchBookingsAccumulatedAsync({ payload }) {
    const params = payload.params || {
        size: payload.size,
        offset: payload.offset,
        sort_by: payload.sort.field,
        sort_direction: payload.sort.order,
    };

    try {
        const url = `${ config.getApiBaseUrl() }/bookings`;

        const response = yield apiClient.read(url, params);

        yield put(fetchBookings.fetchBookingsSuccess(response));
    } catch (error) {
        yield put(fetchBookings.fetchBookingsFailure(error));
    }
}

function* fetchBookingsAsync({ payload }) {
    try {
        const url = `${ config.getApiBaseUrl() }/bookings`;

        const response = yield apiClient.read(url, payload);

        yield put(fetchBookings.fetchBookingsSuccess(response));
    } catch (error) {
        yield put(fetchBookings.fetchBookingsFailure(error));
    }
}

function* fetchBookingAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ id }`;

        const response = yield apiClient.read(url);

        yield put(fetchBookings.fetchBookingSuccess(response));

        yield onSuccess();
    } catch (error) {
        yield put(fetchBookings.fetchBookingFailure(error));

        yield onError(error);
    }
}

function* updateBookingAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ id }`;

        const response = yield apiClient.update(url, values);

        yield put(updateBookings.updateBookingSuccess(id, response));

        yield onSuccess();
    } catch (error) {
        // Trigger the error action.
        yield put(updateBookings.updateBookingFailure(error));

        yield onError(error);
    }
}

function* amendBookingAsync({ payload }) {
    const {
        id,
        onError,
        onSuccess,
        values,
    } = payload;

    try {
        const response = yield updateBookingAmendRequest(id, values);

        yield put(amendBookings.amendBookingSuccess(id, response));

        yield onSuccess();
    } catch (error) {
        // Trigger the error action.
        yield put(amendBookings.amendBookingFailure(error));

        yield onError(error);
    }
}

function* cancelBookingAsync({ payload }) {
    const {
        id,
    } = payload;

    try {
        const url = `${ config.getApiBaseUrl() }/bookings/${ id }/cancel`;

        const response = yield apiClient.update(url);

        yield put(cancelBookings.cancelBookingSuccess(response));
    } catch (error) {
        yield put(cancelBookings.cancelBookingFailure(error));
    }
}

function* cancelBookingSuccessAsync() {
    const getBooking = yield select(getBookingStore);

    yield put(fetchBookings.fetchBookings({
        offset: getBooking.offset,
        page: getBooking.page,
    }));

    yield put(showNotification('notifications.booking.cancelled', 'success'));
}

function* failureMessage({ error }) {
    const { message } = error.response || {};

    yield put(showNotification(message || 'general.error', 'warning'));
}

function* exportBookingsAsync({ params }) {
    try {
        const url = `${ config.getApiBaseUrl() }/export`;

        yield apiClient.read(url, params);

        yield put(exportBookings.exportBookingsSuccess());
    } catch (error) {
        yield put(exportBookings.exportBookingsFailure());
    }
}

function* exportBookingFailureAsync() {
    yield put(showNotification('notifications.export.failure'));
}

function* exportBookingSuccessAsync() {
    yield put(showNotification('notifications.export.success'));
}

function* exportFullBookingsAsync({ params }) {
    try {
        const url = `${ config.getApiBaseUrl() }/booking-reservations/export`;

        yield apiClient.read(url, params);

        yield put(exportFullBookings.exportFullBookingsSuccess());
    } catch (error) {
        yield put(exportFullBookings.exportFullBookingsFailure());
    }
}

function* exportFullBookingFailureAsync() {
    yield put(showNotification('notifications.export.failure'));
}

function* exportFullBookingSuccessAsync() {
    yield put(showNotification('notifications.export.success'));
}

export default function* bookingsSagas() {
    yield [
        takeEvery(types.FETCH_BOOKINGS, fetchBookingsAsync),
        takeEvery(types.FETCH_BOOKINGS_ACCUMULATED, fetchBookingsAccumulatedAsync),
        takeEvery(types.FETCH_BOOKINGS_FAILURE, failureMessage),

        takeEvery(types.FETCH_BOOKING, fetchBookingAsync),
        takeEvery(types.FETCH_BOOKING_FAILURE, failureMessage),

        takeEvery(types.UPDATE_BOOKING, updateBookingAsync),
        takeEvery(types.UPDATE_BOOKING_FAILURE, failureMessage),

        takeEvery(types.AMEND_BOOKING, amendBookingAsync),
        takeEvery(types.AMEND_BOOKING_FAILURE, failureMessage),

        takeEvery(types.CANCEL_BOOKING, cancelBookingAsync),
        takeEvery(types.CANCEL_BOOKING_FAILURE, failureMessage),
        takeEvery(types.CANCEL_BOOKING_SUCCESS, cancelBookingSuccessAsync),

        takeEvery(types.BOOKING_EXPORT, exportBookingsAsync),
        takeEvery(types.BOOKING_EXPORT_FAILURE, exportBookingFailureAsync),
        takeEvery(types.BOOKING_EXPORT_SUCCESS, exportBookingSuccessAsync),

        takeEvery(types.FULL_BOOKING_EXPORT, exportFullBookingsAsync),
        takeEvery(types.FULL_BOOKING_EXPORT_FAILURE, exportFullBookingFailureAsync),
        takeEvery(types.FULL_BOOKING_EXPORT_SUCCESS, exportFullBookingSuccessAsync),
    ];
}



// WEBPACK FOOTER //
// ./src/store/sagas/bookings/bookingsSagas.js